import levels from './levels'

const getDefaultState = () => {
  return {
    // The qualifications currently visible
    active: [],
    // Used to indicate when waiting on the server
    loading: false,
    // The search string being applied
    search: '',
    // What filters are currently applied
    filters: {},
    // The total records matching the filter according to the server (for pagination)
    total: 0,
    // The current page being viewed and its size
    page: 1,
    rowsPerPage: 25,
    // Sorting
    sort: {
      by: null,
      descending: false,
    },
  }
}

const state = getDefaultState()

const getters = {
  active: state => state.active,
  find: state => state.active.find(qualification => qualification.id == Vue.$route.params.id),
  loading: state => state.loading,
}

const mutations = {
  resetState(state) {
    Object.assign(state, getDefaultState())
  },

  startLoading(state) {
    state.loading = true
  },

  stopLoading(state) {
    state.loading = false
  },

  setActive(
    state,
    {
      items = [],
      page = 1,
      per = 25,
      total = 0,
      search = null,
      sort = { by: null, descending: true },
      filters = {},
    }
  ) {
    state.search = search
    state.active = items
    state.sort = sort
    state.filters = filters
    state.page = page
    state.rowsPerPage = per
    state.total = total
    state.loading = false
  },

  set(state, qualification) {
    const find = state.active.find(s => s.id === qualification.id)
    if (find) state.active.splice(state.active.indexOf(find), 1, qualification)
    if (!find) state.active.push(qualification)
  },

  remove(state, id) {
    state.active = state.active.filter(qualification => qualification.id != id)
  },
}

const actions = {
  search(
    { commit, state },
    {
      search = '',
      page = 1,
      rowsPerPage = 25,
      sortBy,
      descending = true,
      filters = {},
    } = {}
  ) {
    this.$authorize('list', 'Qualification')

    const params = {
      search: search,
      page: page,
      per: rowsPerPage,
      sort: sortBy ? `${sortBy} ${descending ? 'DESC' : 'ASC'}` : null,
      ...filters,
    }

    state.loading = true
    return Vue.$http
      .get('admin/qualifications', { params })
      .then(response => commit('setActive', response.data), error => (state.loading = false))
  },

  fetch({ commit }, id) {
    this.$authorize('read', 'Qualification')

    return Vue.$http
      .get(`admin/qualifications/${id}`)
      .then(response => commit('set', response.data))
  },

  create({ commit }, qualification) {
    this.$authorize('create', 'Qualification')

    return Vue.$http.post('admin/qualifications', { qualification }).then(
      response => {
        commit('set', response.data)
        commit(
          'snackbar',
          { text: 'Qualification was created successfully', type: 'success' },
          { root: true }
        )
        return response.data
      },
      error => {
        commit(
          'snackbar',
          { text: 'There was a problem creating the qualification', type: 'error' },
          { root: true }
        )
        return Object.assign(qualification, error.response.data)
      }
    )
  },

  update({ commit }, qualification) {
    this.$authorize('edit', 'Qualification')

    return Vue.$http
      .patch(`admin/qualifications/${qualification.id}`, { qualification })
      .then(
        response => commit('set', response.data),
        response => commit('set', Object.assign(qualification, response.data))
      )
  },

  destroy({ commit }, id) {
    this.$authorize('delete', 'Qualification')

    return Vue.$http.delete(`admin/qualifications/${id}`).then(response => commit('remove', id))
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
  modules: {
    levels,
  },
}
